import { Box, Checkbox, useBoolean } from '@chakra-ui/react';
import {
    Card,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Button,
    Text,
} from 'components/v4';

const walkthroughIdModal = {
    ufCancelButton: '/services-profile-add/modal/confirmation/cancel',
    ufAddButton: '/services-profile-add/modal/confirmation/add',
};

function PartnerConfirmationModal({
    colorScheme,
    darkMode,
    handleSubmit,
    isOpen,
    onClose,
    partnerName,
}) {
    const [check, setCheck] = useBoolean();
    const onPartnerModalClose = () => {
        onClose();
        setCheck.off();
    };
    return (
        <Modal
            closeOnOverlayClick
            isCentered
            isOpen={isOpen}
            onClose={onPartnerModalClose}
            size="md">
            <ModalOverlay backdropFilter="blur(10px)" />
            <ModalContent as="form" onSubmit={handleSubmit}>
                <Card
                    bg={darkMode ? 'dark.tcap' : null}
                    borderRadius={10}
                    key="dashboard-services/add-service-partner-confirmation"
                    data-walkthroughid="dashboard-services/add-service-partner-confirmation">
                    <ModalHeader className="flex items-center justify-center">
                        Service Provisioning Warning
                    </ModalHeader>
                    <ModalBody>
                        <Box mb={8}>
                            You are about to provision a new service for{' '}
                            <strong>{partnerName}</strong>, a Partner Company.
                            This action is permanent and may impact billing or
                            service availability for the selected entity. Please
                            verify the company details before proceeding.
                        </Box>
                        <Box
                            aria-label="checkbox-wrapper"
                            onClick={setCheck.toggle}
                            className="bg-(var--chakra-colors-dark-bgDark) group mb-2 flex w-full cursor-pointer items-start space-x-3 rounded-lg border border-gray-200 p-[16px] transition-all hover:!border-blue-300">
                            <Box className="relative mt-0.5 flex items-center">
                                <Checkbox
                                    m={0}
                                    isChecked={check}
                                    onChange={setCheck.toggle}
                                />
                            </Box>

                            <Text>
                                I verify the selected Partner Company is correct
                                and wish to proceed.
                            </Text>
                        </Box>
                    </ModalBody>
                    <ModalFooter className="flex justify-center">
                        <Button
                            type="button"
                            variant="outline"
                            className="secondary mr-4 !w-full"
                            onClick={onPartnerModalClose}
                            data-walkthroughid={
                                walkthroughIdModal.ufCancelButton
                            }>
                            Cancel
                        </Button>
                        <Button
                            isDisabled={!check}
                            bg={`${colorScheme}.500`}
                            _hover={{
                                bg: `${colorScheme}.600`,
                            }}
                            className={`flex min-h-[38px] !w-full items-center justify-center rounded-md px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--chakra-colors-${colorScheme}-600)]`}
                            type="submit"
                            data-walkthroughid={walkthroughIdModal.ufAddButton}>
                            Confirm
                        </Button>
                    </ModalFooter>
                </Card>
            </ModalContent>
        </Modal>
    );
}

export default PartnerConfirmationModal;
